/* eslint-disable consistent-return */
import React, { Component } from 'react';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import { renderInfoForType, generateImges, showGridTable } from '../../utils/helpers';
import styles from './components/forms/forms.module.scss';

class CustomPrint extends Component {
  constructor() {
    super();
    this.state = {};
  }

  handlePrintFieldName = (fieldId, optionVal) => {
    const { allAirportInfo } = this.props;
    let formAnswer = allAirportInfo.form_details;
    let schemaFields = [];
    let viewObj = {};
    if (formAnswer && Object.keys(formAnswer)?.length > 0) {
      schemaFields = formAnswer?.form_version?.schema?.fields;
      viewObj = schemaFields.find(eachField => eachField.id === fieldId);
      if (viewObj?.type === 'select' && optionVal) {
        return viewObj?.values?.find(checkVal => checkVal.key === optionVal)?.value;
      }
      if (viewObj?.type === 'multiselect' && optionVal) {
        return viewObj?.values?.find(checkVal => checkVal.key === optionVal)?.value;
      }
        return viewObj?.title;
    }
  }

  handleFieldValue = (fieldId, optionVal) => {
    const { allAirportInfo } = this.props;
    let formAnswer = allAirportInfo.form_details;
    let schemaFields = [];
    let viewObj = {};
    if (formAnswer && Object.keys(formAnswer)?.length > 0) {
      schemaFields = formAnswer?.form_version?.schema?.fields;
      viewObj = schemaFields.find(eachField => eachField.id === fieldId);
      if (viewObj?.type === 'select' && optionVal) {
        return formAnswer?.data?.[viewObj?.id] === optionVal ? 'checked' : '';
      }
      if (viewObj?.type === 'multiselect' && optionVal) {
        return formAnswer?.data?.[viewObj?.id].filter(e => e === optionVal).length > 0 ? 'checked' : '';
      }
      if (viewObj?.type === 'signature') {
        return formAnswer?.data?.[viewObj?.id]?.[0]?.url;
      }
      if (viewObj?.type === 'date') {
        return renderInfoForType(viewObj, formAnswer?.data?.[viewObj?.id], null, null);
      }
      if (viewObj?.type === 'time') {
        let timeObj = renderInfoForType(viewObj, formAnswer?.data?.[viewObj?.id], null, null);
          if (optionVal === 'noampm' && timeObj.includes('AM')) {
            return timeObj.replace(' AM', '');
          }
          if (optionVal === 'noampm' && timeObj.includes('PM')) {
            return timeObj.replace(' PM', '');
          }
          if (optionVal === 'am' && timeObj.includes('AM')) {
            return 'checked';
          }
          if (optionVal === 'pm' && timeObj.includes('PM')) {
            return 'checked';
          }
          return renderInfoForType(viewObj, formAnswer?.data?.[viewObj?.id], null, null);
      }
      return formAnswer?.data?.[viewObj?.id];
    }
    return null;
  };

  render() {
    const { allAirportInfo, tileName } = this.props;
    let formAnswer = allAirportInfo.form_details;
    if (allAirportInfo && allAirportInfo?.form_tile?.template_type === 'custom_print') {
        if (formAnswer && formAnswer?.form_version && formAnswer?.key && allAirportInfo.form_template[0]
          && formAnswer?.form_version?.schema?.fields
          && Object.keys(allAirportInfo?.form_template[0])?.length > 0) {
          let newObj = {};
          formAnswer.form_version.schema.fields.map((eachField) => {
            if (eachField.type === 'attachments') {
              newObj = {
                ...newObj,
                [eachField.id]: formAnswer?.data[eachField.id]?.[0]?.url
              };
            } else if (eachField.type === 'boolean') {
              newObj = {
                ...newObj,
                isfieldChecked: formAnswer?.data[eachField.id] ? 'checked' : '',
                [eachField.id]: formAnswer?.data[eachField.id] ? 'checked' : ''
              };
            } else if (eachField.type === 'multiselect') {
              newObj = {
                ...newObj,
                [eachField.id]: eachField?.values?.filter(val => formAnswer?.data[eachField.id]
                    ?.filter(selectKey => selectKey === val.key)?.length > 0)?.map(newVal => newVal?.value)
                };
            } else {
              newObj = {
                ...newObj,
                [eachField.id]: renderInfoForType(eachField, formAnswer?.data[eachField.id], formAnswer?.form_version, true, null) || ''
              };
            }
            if (eachField.type === 'date') {
              const totalDate = formAnswer?.data[eachField.id];
              const total = new Date(totalDate);
              const DateValue ={
                formDate: total.getDate(),
                formMonth: total.getMonth(),
                formYear: total.getFullYear()
              };
                newObj = {
                  ...newObj,
                 [eachField.id]: DateValue
                };
            }
            return eachField;
          });
          const multiFieldData = formAnswer?.form_version?.schema?.fields?.filter(field => field.type==='multi_field');
          formAnswer.printTemplateData = {
          ...newObj,
          createdBy: formAnswer?.created_by?.fullname || formAnswer?.created_by?.first_name || '',
          createdDate: renderInfoForType({ type: 'datetime' }, formAnswer?.created_at, null, null),
          logo: allAirportInfo?.airport_logo,
          formTitle: `${formAnswer?.title} #${moment(
              formAnswer?.form_date
            ).format('YY')} - ${formAnswer?.order_number}`,
            multiGridFields: multiFieldData?.reduce((a, v) => ({ ...a, [v?.id]: v?.multiple_fields }), {})
          };
          formAnswer.showMultiImg = generateImges;
          formAnswer.showGridTable = showGridTable;
        }
      }
      let printTemplateList = allAirportInfo.form_template === null || (allAirportInfo && allAirportInfo?.form_template[0]);
    return (
      <div>
        <Col lg={12} className={styles.cardHeight}>
          <Card className={`${styles.formCard} border-0`}>
            <div className="drag-handle">
            <CardTitle className={styles.airfieldscardtitle}>
              <Col lg={12}>
                <Row>
                  <Col>
                    {tileName && (
                      <FormattedMessage
                        id="airfieldconditionreport.tilename"
                        defaultMessage="{tileName}"
                        values={{ tileName }}
                      />
                    )}
                  </Col>
                </Row>
              </Col>
            </CardTitle>
            </div>
          <hr className={styles.hrLine} />
          <CardBody className={styles.formCardBody}>
          <Col lg={12} className={styles.formcard}>
          <div className={styles.container}>
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              // eslint-disable-next-line no-eval
              __html: eval(`\`${
                 printTemplateList?.[Object.keys(printTemplateList)[0]]?.templateData || ''}\``)
            }}
          />
          </div>
          <div className={styles.bottomStyle} />
          </Col>
          </CardBody>
          </Card>
        </Col>
      </div>
    );
  }
}

export default CustomPrint;
